export default __webpack_public_path__ + "img/1_5-c56095ed.png";